import React from 'react';
import { Link } from 'react-router-dom';
import { TERMS_SUMMARY } from '../pages/Public/activationModel';

/** Historical checkout summary, never represented as the missing full MSA. */
export default function LegacyBusinessSummary() {
  return (
    <main className="mx-auto max-w-4xl p-6 sm:p-10 leading-7 text-gray-900">
      <h1 className="text-3xl font-semibold">Business agreement documents</h1>
      <p className="my-5 rounded border bg-gray-50 p-4">
        The text below is the legacy v3.0 checkout summary. It is not the
        complete MSA or a copy of a signed customer agreement. Your separately
        accepted Order and signed agreement remain controlling. A new standard
        agreement is not effective on this page.
      </p>
      <h2 className="text-xl font-semibold">Legacy v3.0 summary</h2>
      {TERMS_SUMMARY.map((text) => (
        <p key={text.slice(0, 30)} className="mt-4">
          {text}
        </p>
      ))}
      <nav aria-label="Related legal documents" className="mt-8 flex gap-4">
        <Link to="/legal/sms" className="underline">
          SMS Terms
        </Link>
        <Link to="/legal/privacy" className="underline">
          Privacy Policy
        </Link>
      </nav>
    </main>
  );
}
